const paymentTypes = {
  'cash': '08',
  'bankCard': '01',
  'online': '01',
  'voucher': '03',
  'other': '04',
  'cashEuro': '07',
  'szepkartya': '03',
  'transfer': '05',
  'credit': '04',
  'vip': '03'
}

// Bankkártya 01
// minta
// Csekk 02
// Utalvány 03
// Hitel 04
// Átutalás 05
// Vevő számla 06
// EURO 07
// Készpénz 08

function micraSentoNanoSale(fiscalReceipt) {
  if (!fiscalReceipt) return { success: false, message: 'No fiscalReceipt' }
  let res = {}
  res.paymentsTotal = fiscalReceipt.paymentsTotal
  res.codes = []
  for (let [vatRegister, price] of Object.entries(fiscalReceipt.vatRegisterSums)) {
    let code = `2${(vatRegister + '').padStart(13, '0')}${('1').padStart(10, '0')}${(price + '').padStart(10, '0')}`
    res.codes.push(code)
  }
  for (let payment of fiscalReceipt.payments) {
    let code = `#b${(paymentTypes[payment.agentType] || '01')}${(payment.amount+''.padStart(10, '0'))}`
    res.codes.push(code)
  }
  return res
}


export {
  micraSentoNanoSale
}
